import { ENUM_CURRENCY, RENDERER_TYPES } from "../../../../enums";
import { convertToFullName, numberFormat } from "../../../../services/utils";
import { SimpleTable } from "../../../../components/mui/table";
import { PaymentStatus } from "../../../components/payment-status";
import {
  DATE_FORMATS,
  formatDate,
} from "../../../../services/date-and-time.utils";
import { AmbassadorPaymentListExpandedRowData } from "./expanded-row-data";
import { InitialNameAvatar } from "../../../../components/images/initial-name-avatar";

function AmbassadorPaymentListTable({
  list,
  columns,
  handlePageFilters,
  appliedFilters,
}) {
  const { selectedPage, selectedPageSize } = appliedFilters;

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME_WITH_AVATAR:
        return (
          <InitialNameAvatar
            text={convertToFullName(row.firstName, row.lastName)}
            name={row.firstName}
            image
            src={row.picture}
          />
        );
      case RENDERER_TYPES.FULL_DATE:
        return formatDate(row.createdAt, DATE_FORMATS.fullDateWithTime);
      case RENDERER_TYPES.AMOUNT:
        return `${numberFormat(row[column.field], ENUM_CURRENCY.USD)}`;
      case RENDERER_TYPES.PAYMENT_STATUS:
        return <PaymentStatus data={row} />;
      default:
        break;
    }
  };

  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      columns={columns}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      showPagination={false}
      fetching={list?.loading}
      renderExpandedRowData={({ row }) => (
        <AmbassadorPaymentListExpandedRowData data={row.payments} />
      )}
      exandableRow
    ></SimpleTable>
  );
}

export { AmbassadorPaymentListTable };
